var map = {
	"./css/antd.css": "./src/assets/css/antd.css",
	"./css/antd.css.map": "./src/assets/css/antd.css.map",
	"./css/bootstrap.css": "./src/assets/css/bootstrap.css",
	"./css/bootstrap.css.map": "./src/assets/css/bootstrap.css.map",
	"./css/home-page.css": "./src/assets/css/home-page.css",
	"./css/main.css": "./src/assets/css/main.css",
	"./css/styles.css": "./src/assets/css/styles.css",
	"./css/util.css": "./src/assets/css/util.css",
	"./documents/manual_CookBook.pdf": "./src/assets/documents/manual_CookBook.pdf",
	"./documents/manual_CookBookOLD.pdf": "./src/assets/documents/manual_CookBookOLD.pdf",
	"./documents/manual_WEBCONI.pdf": "./src/assets/documents/manual_WEBCONI.pdf",
	"./fonts/Chalkboard.ttc": "./src/assets/fonts/Chalkboard.ttc",
	"./fonts/DejaVuSans.ttf": "./src/assets/fonts/DejaVuSans.ttf",
	"./fonts/GoodDog.ttf": "./src/assets/fonts/GoodDog.ttf",
	"./fonts/Helvetica.dfont": "./src/assets/fonts/Helvetica.dfont",
	"./fonts/PalatinoBold.ttf": "./src/assets/fonts/PalatinoBold.ttf",
	"./images/CompassGroupNegativoES600x300.png": "./src/assets/images/CompassGroupNegativoES600x300.png",
	"./images/alergenoAltramuces.png": "./src/assets/images/alergenoAltramuces.png",
	"./images/alergenoApio.png": "./src/assets/images/alergenoApio.png",
	"./images/alergenoCacahuetes.png": "./src/assets/images/alergenoCacahuetes.png",
	"./images/alergenoCrustaceos.png": "./src/assets/images/alergenoCrustaceos.png",
	"./images/alergenoDxoAzufreSulfitos.png": "./src/assets/images/alergenoDxoAzufreSulfitos.png",
	"./images/alergenoFrutaCascara.png": "./src/assets/images/alergenoFrutaCascara.png",
	"./images/alergenoGluten.png": "./src/assets/images/alergenoGluten.png",
	"./images/alergenoGranosSesamo.png": "./src/assets/images/alergenoGranosSesamo.png",
	"./images/alergenoHuevos.png": "./src/assets/images/alergenoHuevos.png",
	"./images/alergenoLacteos.png": "./src/assets/images/alergenoLacteos.png",
	"./images/alergenoMoluscos.png": "./src/assets/images/alergenoMoluscos.png",
	"./images/alergenoMostaza.png": "./src/assets/images/alergenoMostaza.png",
	"./images/alergenoPescado.png": "./src/assets/images/alergenoPescado.png",
	"./images/alergenoSoja.png": "./src/assets/images/alergenoSoja.png",
	"./images/alergenosIconos.png": "./src/assets/images/alergenosIconos.png",
	"./images/alergenosIcons.png": "./src/assets/images/alergenosIcons.png",
	"./images/alergenosIconsNuevos.png": "./src/assets/images/alergenosIconsNuevos.png",
	"./images/banner1.jpg": "./src/assets/images/banner1.jpg",
	"./images/banner2-old.jpg": "./src/assets/images/banner2-old.jpg",
	"./images/banner2.jpg": "./src/assets/images/banner2.jpg",
	"./images/banner2OLD.jpg": "./src/assets/images/banner2OLD.jpg",
	"./images/banner3-old.jpg": "./src/assets/images/banner3-old.jpg",
	"./images/banner3.jpg": "./src/assets/images/banner3.jpg",
	"./images/banner4.jpg": "./src/assets/images/banner4.jpg",
	"./images/banner5.jpg": "./src/assets/images/banner5.jpg",
	"./images/banner7.jpg": "./src/assets/images/banner7.jpg",
	"./images/bg-01.jpg": "./src/assets/images/bg-01.jpg",
	"./images/bg-01OLD.jpg": "./src/assets/images/bg-01OLD.jpg",
	"./images/favicon.png": "./src/assets/images/favicon.png",
	"./images/iconosAlergenos.jpg": "./src/assets/images/iconosAlergenos.jpg",
	"./images/imagenPorDefecto.png": "./src/assets/images/imagenPorDefecto.png",
	"./images/imagenPorDefectoP1-2.png": "./src/assets/images/imagenPorDefectoP1-2.png",
	"./images/logo.png": "./src/assets/images/logo.png",
	"./images/logoCompassGroup.png": "./src/assets/images/logoCompassGroup.png",
	"./images/logoCookBook.png": "./src/assets/images/logoCookBook.png",
	"./images/logoCookBook2.png": "./src/assets/images/logoCookBook2.png",
	"./images/logoEurestCatalunya.png": "./src/assets/images/logoEurestCatalunya.png",
	"./images/logoEurestColectividades.png": "./src/assets/images/logoEurestColectividades.png",
	"./images/logoEurestEuskadi.png": "./src/assets/images/logoEurestEuskadi.png",
	"./images/logoEurestServices.png": "./src/assets/images/logoEurestServices.png",
	"./images/logoMedirest.png": "./src/assets/images/logoMedirest.png",
	"./images/logoScolarest.png": "./src/assets/images/logoScolarest.png",
	"./images/logoVilaplana.png": "./src/assets/images/logoVilaplana.png",
	"./images/logoVitarest.png": "./src/assets/images/logoVitarest.png",
	"./images/logosEtiquetas/logosColores/AytoCorunna.jpg": "./src/assets/images/logosEtiquetas/logosColores/AytoCorunna.jpg",
	"./images/logosEtiquetas/logosColores/CompassGroup.jpg": "./src/assets/images/logosEtiquetas/logosColores/CompassGroup.jpg",
	"./images/logosEtiquetas/logosColores/EAP.jpg": "./src/assets/images/logosEtiquetas/logosColores/EAP.jpg",
	"./images/logosEtiquetas/logosColores/Eurest.jpg": "./src/assets/images/logosEtiquetas/logosColores/Eurest.jpg",
	"./images/logosEtiquetas/logosColores/EurestCatalunya.jpg": "./src/assets/images/logosEtiquetas/logosColores/EurestCatalunya.jpg",
	"./images/logosEtiquetas/logosColores/EurestEuskadi.jpg": "./src/assets/images/logosEtiquetas/logosColores/EurestEuskadi.jpg",
	"./images/logosEtiquetas/logosColores/EurestServices.jpg": "./src/assets/images/logosEtiquetas/logosColores/EurestServices.jpg",
	"./images/logosEtiquetas/logosColores/EurestServiciosFeriales.jpg": "./src/assets/images/logosEtiquetas/logosColores/EurestServiciosFeriales.jpg",
	"./images/logosEtiquetas/logosColores/Medirest.jpg": "./src/assets/images/logosEtiquetas/logosColores/Medirest.jpg",
	"./images/logosEtiquetas/logosColores/Scolarest.jpg": "./src/assets/images/logosEtiquetas/logosColores/Scolarest.jpg",
	"./images/logosEtiquetas/logosColores/Vilaplana.jpg": "./src/assets/images/logosEtiquetas/logosColores/Vilaplana.jpg",
	"./images/logosEtiquetas/logosColores/Vitarest.jpg": "./src/assets/images/logosEtiquetas/logosColores/Vitarest.jpg",
	"./images/logosEtiquetas/logosColores/ajuntamentOntinyent.jpg": "./src/assets/images/logosEtiquetas/logosColores/ajuntamentOntinyent.jpg",
	"./images/logosEtiquetas/logosColores/ajuntamentOntinyentOld.jpg": "./src/assets/images/logosEtiquetas/logosColores/ajuntamentOntinyentOld.jpg",
	"./images/logosEtiquetas/logosSinColores/AytoCorunna.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/AytoCorunna.jpg",
	"./images/logosEtiquetas/logosSinColores/CompassGroup.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/CompassGroup.jpg",
	"./images/logosEtiquetas/logosSinColores/DietasDB.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/DietasDB.jpg",
	"./images/logosEtiquetas/logosSinColores/EAP.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/EAP.jpg",
	"./images/logosEtiquetas/logosSinColores/Eurest.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/Eurest.jpg",
	"./images/logosEtiquetas/logosSinColores/EurestCatalunya.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/EurestCatalunya.jpg",
	"./images/logosEtiquetas/logosSinColores/EurestEuskadi.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/EurestEuskadi.jpg",
	"./images/logosEtiquetas/logosSinColores/EurestServices.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/EurestServices.jpg",
	"./images/logosEtiquetas/logosSinColores/EurestServiciosFeriales.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/EurestServiciosFeriales.jpg",
	"./images/logosEtiquetas/logosSinColores/Medirest.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/Medirest.jpg",
	"./images/logosEtiquetas/logosSinColores/Scolarest.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/Scolarest.jpg",
	"./images/logosEtiquetas/logosSinColores/Vilaplana.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/Vilaplana.jpg",
	"./images/logosEtiquetas/logosSinColores/Vitarest.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/Vitarest.jpg",
	"./images/logosEtiquetas/logosSinColores/ajuntamentOntinyent.jpg": "./src/assets/images/logosEtiquetas/logosSinColores/ajuntamentOntinyent.jpg",
	"./images/opcionesPlato/aperitivoPlato.jpg": "./src/assets/images/opcionesPlato/aperitivoPlato.jpg",
	"./images/opcionesPlato/bebidaPlato.jpg": "./src/assets/images/opcionesPlato/bebidaPlato.jpg",
	"./images/opcionesPlato/desayunoPlato.jpg": "./src/assets/images/opcionesPlato/desayunoPlato.jpg",
	"./images/opcionesPlato/desayunoPlatoOLD.jpg": "./src/assets/images/opcionesPlato/desayunoPlatoOLD.jpg",
	"./images/opcionesPlato/guarnicionPlato.jpg": "./src/assets/images/opcionesPlato/guarnicionPlato.jpg",
	"./images/opcionesPlato/imagenBlanco - copia.jpg": "./src/assets/images/opcionesPlato/imagenBlanco - copia.jpg",
	"./images/opcionesPlato/imagenBlanco.jpg": "./src/assets/images/opcionesPlato/imagenBlanco.jpg",
	"./images/opcionesPlato/mediaMannana.jpg": "./src/assets/images/opcionesPlato/mediaMannana.jpg",
	"./images/opcionesPlato/merienda.jpg": "./src/assets/images/opcionesPlato/merienda.jpg",
	"./images/opcionesPlato/panPlato.jpg": "./src/assets/images/opcionesPlato/panPlato.jpg",
	"./images/opcionesPlato/postrePlato.jpg": "./src/assets/images/opcionesPlato/postrePlato.jpg",
	"./images/opcionesPlato/primerPlato.jpg": "./src/assets/images/opcionesPlato/primerPlato.jpg",
	"./images/opcionesPlato/segundoPlato.jpg": "./src/assets/images/opcionesPlato/segundoPlato.jpg",
	"./images/opcionesPlato/sinOpcionPlato.jpg": "./src/assets/images/opcionesPlato/sinOpcionPlato.jpg",
	"./images/opcionesPlato/unicoPlato.jpg": "./src/assets/images/opcionesPlato/unicoPlato.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";